import type { GetNodeTypeIdById } from "@skilitics/nautilus-core-designer-data";

import type { GetNodeAncestorIds } from "./getNodeAncestorIds.ts";

interface CreateOptions {
  getAncestorIds: GetNodeAncestorIds;
  getTypeId: GetNodeTypeIdById;
  getIsSelectionTarget: (typeId: string) => boolean;
  getNodeIdExists: (id: number) => boolean;
}

/**
 * The nearest `selectionTarget` at or above `nodeId`, or `undefined` if there is none.
 *
 * `nodeId` may be a node rendered inside another node's properties view, which can't be selected on
 * its own.
 */
export const getDeepestSelectionTargetCreate =
  ({ getAncestorIds, getTypeId, getIsSelectionTarget, getNodeIdExists }: CreateOptions): GetDeepestSelectionTarget =>
  (nodeId) =>
    // a published cycle can name a node the design has no type for
    [nodeId, ...getAncestorIds(nodeId)].find((id) => getNodeIdExists(id) && getIsSelectionTarget(getTypeId(id)));

export type GetDeepestSelectionTarget = (id: number) => number | undefined;
